var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjectInfoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2266 4.125V9.625C21.2266 9.98967 21.3795 10.3394 21.6518 10.5973C21.9241 10.8551 22.2933 11 22.6784 11H28.4856",
    stroke: "#0C6CDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.582 28.875H11.0639C10.2938 28.875 9.55526 28.5853 9.01073 28.0695C8.46619 27.5538 8.16028 26.8543 8.16028 26.125V6.875C8.16028 6.14565 8.46619 5.44618 9.01073 4.93046C9.55526 4.41473 10.2938 4.125 11.0639 4.125H21.2266L28.4856 11V26.125C28.4856 26.8543 28.1797 27.5538 27.6351 28.0695C27.0906 28.5853 26.3521 28.875 25.582 28.875Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9675 9.625H15.4193",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9675 17.875H22.6784",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7747 23.375H22.6784",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectInfoBlue);
export default __webpack_public_path__ + "static/media/Icon_ProjectInfo_Blue.a121904738e4a7bbbbefc91425f5c98a.svg";
export { ForwardRef as ReactComponent };